export default __webpack_public_path__ + "static/media/Tiina Simola.494ce74b.webp";